import { render, staticRenderFns } from "./Evaluation-user-form.vue?vue&type=template&id=b5189720&scoped=true"
import script from "./Evaluation-user-form.vue?vue&type=script&lang=js"
export * from "./Evaluation-user-form.vue?vue&type=script&lang=js"
import style0 from "./Evaluation-user-form.vue?vue&type=style&index=0&id=b5189720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5189720",
  null
  
)

export default component.exports